import { Movement } from './analysis/movements.model';
import { DegreeOfFreedom } from './degree-of-freedom.enum';
import { ParameterVariable } from './parameter-variable.enum';

export class LoadingCase {
  id: number;
  title: string;
  internalId: number;
  currentId: number;
  waveId: number;
  relativeShipWaveAngle: number;
  raoFilePeak1: number;
  raoFilePeak2: number;
  nodeId: number;
  variableToMaximize: ParameterVariable;
  degreeOfFreedom: DegreeOfFreedom;
  startTime: number;
  stormTime: number;
  considerSecondOrderMov: boolean;
  movements: Movement[];

  constructor() {}
}
